import { Button, Flex, Popconfirm, Spin } from 'antd';
import { IWorkState } from 'models';

interface CreateWorkButtonsProps {
	loading?: boolean;
	handleCancel: () => void;
	onDeleteJob: () => void;
	state?: IWorkState;
	lostWork: () => void;
	submitForm: () => void;
	openHistory: () => void;
}

export const CreateWorkButtons = ({ submitForm, loading, handleCancel, onDeleteJob, state, lostWork, openHistory }: CreateWorkButtonsProps) => {
	return (
		<Spin spinning={loading}>
			<Flex gap={8}>
				<Button 
					key="cancel" 
					onClick={handleCancel}
				>Cancel</Button>
				{state && (
					<Popconfirm
						title="Are you sure to delete this job?"
						onConfirm={onDeleteJob}
						okText="Yes"
						cancelText="No"
						key="delete"
					>
						<Button
							danger
							type="primary"
						>Delete</Button>
					</Popconfirm>
				)}
				{state !== IWorkState.LOST && (
					<>
						<Button
							key="submit"
							type="primary"
							onClick={submitForm}
						>Submit</Button>
						{state && (
							<Button
								danger
								onClick={lostWork}
							>Lost</Button>
						)}
					</>
				)}
				{state && (
					<Button 
						key="history" 
						onClick={() => openHistory()}
						variant="outlined"
						color="primary"
					>History</Button>
				)}
			</Flex>
		</Spin>
	);
};